export enum PaymentIntentStatus {
  PROCESSING = 'processing',
  SUCCEEDED = 'succeeded',
  UNSET = '',
}
